import React, { useEffect, useRef, useState } from 'react';
import './Products.css';
import $ from 'jquery';

// Import product images and gifs
import aiImage from '../../asset/Products/AI/AIVideobooth.png';
import aiGif from '../../asset/Products/AI/AIVideoBooth.gif';
import gamesImage from '../../asset/Products/Games/Games.png';
import gamesGif from '../../asset/Products/Games/Games.gif';
import kineticImage from '../../asset/Products/Kinetic Installation/Kinetic.jpg';
import kineticGif from '../../asset/Products/Kinetic Installation/Kinetic.gif';
import roboticsImage from '../../asset/Products/Robotics/Robotics.jpeg';
import roboticsGif from '../../asset/Products/Robotics/Robotics.gif';
import photoboothImage from '../../asset/Products/Photobooth/Photobooth.png';
import photoboothGif from '../../asset/Products/Photobooth/Photobooth.gif';
import entertainmentImage from '../../asset/Products/Entertainment/Entertainment.jpg';
import entertainmentGif from '../../asset/Products/Entertainment/Entertainment.gif';
import projectionMappingImage from '../../asset/Products/Projection Mapping/ProjectionMapping.png';
import projectionMappingGif from '../../asset/Products/Projection Mapping/ProjectionMapping.gif';
import hologramImage from '../../asset/Products/Hologram/Hologram.png';
import hologramGif from '../../asset/Products/Hologram/Hologram.gif';

// Standalone ProductCard component with 3D effect
const ProductCard = ({ title, image, gifImage }) => {
  const cardRef = useRef(null);
  const textContainerRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const card = cardRef.current;
    const textContainer = textContainerRef.current;
    const text = textRef.current;
    
    if (!card || !textContainer || !text) return;
    
    // Preload GIF
    const preloadGif = new Image();
    preloadGif.src = gifImage;
    
    // Variables for tracking mouse position
    let bounds;
    
    // Get bounds of card for calculations
    const getBounds = () => {
      bounds = card.getBoundingClientRect();
    };
    
    // Calculate card rotation based on mouse position
    const rotateCard = (e) => {
      if (!bounds) getBounds();
      
      // Get mouse position relative to card
      const mouseX = e.clientX - bounds.left;
      const mouseY = e.clientY - bounds.top;
      
      // Calculate rotation (normalize to -1 to 1, then multiply by max rotation)
      const rotateY = ((mouseX / bounds.width) - 0.5) * 40; // -20 to 20 degrees
      const rotateX = (((mouseY / bounds.height) - 0.5) * -40); // -20 to 20 degrees (inverted)
      
      // Apply transform to card
      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(50px)`;
      card.style.boxShadow = '0 30px 60px rgba(0, 0, 0, 0.6), 0 0 40px rgba(227, 41, 97, 0.4)';
      card.style.zIndex = '10';
      
      // Apply extreme 3D transform to text container
      textContainer.style.transform = `translateZ(100px)`;
      
      // Apply 3D transform to text with exaggerated perspective
      text.style.transform = `rotateX(${rotateX * 1.2}deg) rotateY(${rotateY * 1.2}deg)`;
      text.style.textShadow = 
        `${rotateY * -0.1}px ${rotateX * 0.1}px 0px rgba(255,0,0,0.8),
         ${rotateY * 0.1}px ${rotateX * -0.1}px 0px rgba(0,255,255,0.8),
         0px 0px 20px rgba(255,255,255,0.8)`;
      
      // Change background image to GIF
      card.style.backgroundImage = `url(${gifImage})`;
      
      // Remove transition for smooth movement
      card.style.transition = 'none';
      textContainer.style.transition = 'none';
      text.style.transition = 'none';
    };
    
    // Reset card when mouse leaves
    const resetCard = () => {
      card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) translateZ(0)';
      card.style.boxShadow = '0 10px 20px rgba(0, 0, 0, 0.3)';
      card.style.zIndex = '5';
      card.style.backgroundImage = `url(${image})`;
      card.style.transition = 'all 0.5s ease';
      
      // Reset text container
      textContainer.style.transform = 'translateZ(0)';
      textContainer.style.transition = 'all 0.5s ease';
      
      // Reset text
      text.style.transform = 'rotateX(0) rotateY(0)';
      text.style.textShadow = '0 2px 5px rgba(0, 0, 0, 0.5)';
      text.style.transition = 'all 0.5s ease';
    };
    
    // Add event listeners
    card.addEventListener('mousemove', rotateCard);
    card.addEventListener('mouseenter', getBounds);
    card.addEventListener('mouseleave', resetCard);
    
    // Clean up event listeners
    return () => {
      card.removeEventListener('mousemove', rotateCard);
      card.removeEventListener('mouseenter', getBounds);
      card.removeEventListener('mouseleave', resetCard);
    };
  }, [image, gifImage]);

  return (
    <div 
      className="product-card-3d" 
      ref={cardRef} 
      style={{ 
        backgroundImage: `url(${image})`,
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '10px',
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '15px',
        boxSizing: 'border-box',
        transition: 'all 0.5s ease',
        transformStyle: 'preserve-3d',
        willChange: 'transform, box-shadow, background-image',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Black overlay for better text visibility */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.6)',
        borderRadius: '10px',
        zIndex: 1,
        transformStyle: 'preserve-3d',
      }}></div>
      
      {/* Text container with 3D effect */}
      <div 
        ref={textContainerRef}
        style={{
          position: 'relative',
          zIndex: 2,
          transformStyle: 'preserve-3d',
          transform: 'translateZ(0)',
          transition: 'all 0.5s ease',
          perspective: '1000px',
          maxWidth: '90%',
        }}
      >
        {/* Title with extreme 3D effect */}
        <div 
          ref={textRef}
          style={{
            color: 'white',
            fontSize: '1.2rem',
            fontWeight: '800',
            textShadow: '0 2px 5px rgba(0, 0, 0, 0.5)',
            margin: '0',
            padding: '10px 15px',
            transformStyle: 'preserve-3d',
            transform: 'rotateX(0) rotateY(0)',
            transition: 'all 0.5s ease',
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            WebkitTextStroke: '1px rgba(255, 255, 255, 0.2)',
            // Create layered text for 3D effect even when static
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: '2px',
              left: '2px',
              right: '0',
              bottom: '0',
              color: 'rgba(255, 0, 0, 0.5)',
              zIndex: -1
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              top: '-2px',
              left: '-2px',
              right: '0',
              bottom: '0',
              color: 'rgba(0, 255, 255, 0.5)',
              zIndex: -2
            }
          }}
        >
          {/* Create layered text spans for true 3D effect */}
          <span style={{ 
            position: 'relative', 
            display: 'inline-block',
            transform: 'translateZ(0px)',
            color: 'rgba(255,255,255,0.9)'
          }}>
            {title}
          </span>
          <span style={{ 
            position: 'absolute', 
            left: '10px', 
            top: '10px',
            display: 'inline-block',
            transform: 'translateZ(-5px)',
            color: 'rgba(255,0,0,0.5)',
            filter: 'blur(1px)',
            opacity: 0.8
          }}>
            {title}
          </span>
          <span style={{ 
            position: 'absolute', 
            left: '10px', 
            top: '10px',
            display: 'inline-block',
            transform: 'translateZ(-10px)',
            color: 'rgba(0,255,255,0.5)',
            filter: 'blur(2px)',
            opacity: 0.6
          }}>
            {title}
          </span>
        </div>
      </div>
    </div>
  );
};

const Products = () => {
  const products = [
    { 
      id: 1,
      title: "AI Solutions", 
      image: aiImage,
      gifImage: aiGif
    },
    { 
      id: 2,
      title: "Interactive Activations", 
      image: gamesImage,
      gifImage: gamesGif
    },
  
    { 
      id: 3,
      title: "Robotics", 
      image: roboticsImage,
      gifImage: roboticsGif
    },
    { 
      id: 4,
      title: "Photobooth", 
      image: photoboothImage,
      gifImage: photoboothGif
    },
    { 
      id: 5,
      title: "Entertainment", 
      image: entertainmentImage,
      gifImage: entertainmentGif
    },
    { 
      id: 6,
      title: "Projection Mapping", 
      image: projectionMappingImage,
      gifImage: projectionMappingGif
    },
    { 
      id: 7,
      title: "Hologram", 
      image: hologramImage,
      gifImage: hologramGif
    },
    { 
      id: 8,
      title: "Kinetic Installation", 
      image: kineticImage,
      gifImage: kineticGif
    },
  ];

  useEffect(() => {
    if (!products || products.length === 0) return;
    
    // Wait for DOM to be ready
    setTimeout(() => {
      const carousel = $('#carousel');
      const threshold = 150;
      const windowWidth = $(window).width();
      let dragStart, dragEnd;
      
      // Responsive slide configuration
      const getSlideConfig = () => {
        const width = $(window).width();
        if (width <= 576) {
          // Mobile - show 1 slide
          return {
            slideWidth: width * 0.85,
            slideMargin: 10,
            slidesToShow: 1
          };
        } else if (width <= 768) {
          // Tablet portrait - show 2 slides
          return {
            slideWidth: width * 0.45,
            slideMargin: 12,
            slidesToShow: 2
          };
        } else if (width <= 992) {
          // Tablet landscape - show 3 slides
          return {
            slideWidth: width * 0.31,
            slideMargin: 15,
            slidesToShow: 3
          };
        } else {
          // Desktop - show 4 slides
          return {
            slideWidth: width * 0.233,
            slideMargin: 15,
            slidesToShow: 4
          };
        }
      };
      
      const initializeCarousel = () => {
        const config = getSlideConfig();
        const { slideWidth, slideMargin } = config;
        
        // Set slide widths
        $('.slide').width(slideWidth);
        
        // Adjust the carousel positioning
        const initialOffset = slideWidth + slideMargin;
        carousel.css('left', `-${initialOffset}px`);
        
        // For better initial positioning, move the last slide to the beginning
        if ($('.slide:first').length && $('.slide:last').length) {
          $('.slide:first').before($('.slide:last'));
        }
        
        // Mark the center slide as active
        $('.slide:eq(1)').addClass('active');
        
        // Ensure all slides have proper z-index
        $('.slide').css('z-index', '1');
        $('.slide.active').css('z-index', '2');
      };
      
      initializeCarousel();
      
      // Enhanced drag/touch handling for mobile
      let startX, moveX, isDragging = false;
      
      // Mouse events
      carousel.on('mousedown', function(event){
        if (carousel.hasClass('transition')) return;
        event.preventDefault();
        isDragging = true;
        dragStart = startX = event.pageX || event.clientX;
        dragEnd = startX; // Initialize dragEnd
        
        // Remove any existing mousemove listeners first
        $(this).off('mousemove.drag');
        
        $(this).on('mousemove.drag', function(event){
          if (!isDragging) return;
          event.preventDefault();
          dragEnd = moveX = event.pageX || event.clientX;
          $(this).css('transform',`translateX(${dragPos()}px)`);
        });
      });
      
      // Touch events for mobile
      carousel.on('touchstart', function(event){
        if (carousel.hasClass('transition')) return;
        event.preventDefault();
        isDragging = true;
        const touch = event.originalEvent.touches[0];
        dragStart = startX = touch.pageX;
        dragEnd = startX; // Initialize dragEnd
        
        // Remove any existing touchmove listeners first
        $(this).off('touchmove.drag');
        
        $(this).on('touchmove.drag', function(event){
          if (!isDragging) return;
          event.preventDefault();
          const touch = event.originalEvent.touches[0];
          dragEnd = moveX = touch.pageX;
          $(this).css('transform',`translateX(${dragPos()}px)`);
        });
      });
      
      // End drag/touch events
      $(document).on('mouseup.drag touchend.drag', function(){
        if (!isDragging) return;
        isDragging = false;
        const threshold = $(window).width() <= 768 ? 50 : 150; // Lower threshold for mobile
        
        if (dragPos() > threshold) { 
          shiftSlide(1); 
        } else if (dragPos() < -threshold) { 
          shiftSlide(-1); 
        } else {
          shiftSlide(0);
        }
        
        // Clean up all drag-related event listeners
        carousel.off('mousemove.drag touchmove.drag');
        $(document).off('mouseup.drag touchend.drag');
        
        // Reset drag values
        dragStart = dragEnd = startX = moveX = 0;
      });
      
      function dragPos() {
        return (dragEnd || moveX || startX) - (dragStart || startX);
      }
      
      function shiftSlide(direction) {
        if (carousel.hasClass('transition')) return;
        isDragging = false;
        dragEnd = dragStart;
        $(document).off('mouseup touchend');
        carousel.off('mousemove touchmove');
        
        const config = getSlideConfig();
        const { slideWidth, slideMargin } = config;
        
        carousel.addClass('transition')
                .css('transform',`translateX(${(direction * (slideWidth + slideMargin * 2))}px)`); 
        
        // Update active slide
        if (direction === 1) {
          $('.slide.active').removeClass('active').prev().addClass('active');
        } else if (direction === -1) {
          $('.slide.active').removeClass('active').next().addClass('active');
        }
        
        // Ensure all slides have proper z-index
        $('.slide').css('z-index', '1');
        $('.slide.active').css('z-index', '2');
        
        setTimeout(function(){
          if (direction === 1) {
            $('.slide:first').before($('.slide:last'));
          } else if (direction === -1) {
            $('.slide:last').after($('.slide:first'));
          }
          carousel.removeClass('transition');
          carousel.css('transform','translateX(0px)'); 
        }, 700);
      }
      
      // Handle prev/next buttons
      $('#prev').on('click', function() {
        shiftSlide(1);
      });
      
      $('#next').on('click', function() {
        shiftSlide(-1);
      });
      
      // Handle window resize
      $(window).on('resize', function() {
        setTimeout(() => {
          initializeCarousel();
        }, 100);
      });
      
    }, 500);
    
    // Cleanup
    return () => {
      $('#carousel').off('mousedown mousemove.drag touchstart touchmove.drag');
      $(document).off('mouseup.drag touchend.drag');
      $(window).off('resize');
      $('#prev, #next').off('click');
    };
  }, [products]);

  return (
    <section style={{ 
      margin: '3rem 0', 
      width: '100%', 
      padding: 0, 
      textAlign: 'center',
      background: 'transparent',
      color: '#fff',
      fontSize: '22pt',
      fontFamily: 'Teko, sans-serif',
      letterSpacing: '0.15em',
      overflow: 'hidden',
      position: 'relative'
    }}>
      <h1>FEATURED PRODUCTS</h1>
      
      {/* Gallery Section - Exactly like ProjectDetailsPage */}
      <div className="gallery-section" style={{ 
        margin: '3rem 0',
        width: '100%',
        padding: 0
      }}>
        <div className="wrap" style={{ 
          position: 'relative',
          width: '100vw',
          height: '400px',
          margin: '0 auto',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw'
        }}>
          <div className="window" style={{ 
            overflow: 'hidden',
            position: 'relative',
            background: 'transparent',
            width: '100%',
            height: '100%'
          }}>
            <div id="carousel" style={{ 
              width: '10000px',
              position: 'relative',
              top: 0,
              height: '100%'
            }}>
              {products.map((product, index) => (
                <div 
                  key={product.id} 
                  className="slide" 
                  id={`b${index + 1}`}
                  style={{
                    height: '400px',
                    cursor: 'pointer',
                    float: 'left',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    position: 'relative',
                    overflow: 'visible',
                    margin: '0 15px',
                    borderRadius: '8px',
                    perspective: '1000px'
                  }}
                >
                  <ProductCard 
                    title={product.title}
                    image={product.image}
                    gifImage={product.gifImage}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/* Navigation buttons */}
        <span 
          id="prev" 
          style={{
            cursor: 'pointer',
            position: 'absolute',
            top: '50%',
            left: 'var(--nav-left, 20px)',
            transform: 'translateY(-50%)',
            fontSize: 'var(--nav-font-size, 14pt)',
            color: '#fff',
            padding: 'var(--nav-padding, 15px)',
            background: 'rgba(0, 0, 0, 0.7)',
            borderRadius: '50%',
            width: 'var(--nav-size, 50px)',
            height: 'var(--nav-size, 50px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }}
        >
          &#8592;
        </span>
        <span 
          id="next" 
          style={{
            cursor: 'pointer',
            position: 'absolute',
            top: '50%',
            right: 'var(--nav-right, 20px)',
            transform: 'translateY(-50%)',
            fontSize: 'var(--nav-font-size, 14pt)',
            color: '#fff',
            padding: 'var(--nav-padding, 15px)',
            background: 'rgba(0, 0, 0, 0.7)',
            borderRadius: '50%',
            width: 'var(--nav-size, 50px)',
            height: 'var(--nav-size, 50px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }}
        >
          &#8594;
        </span>
      </div>

      <style jsx>{`
        .transition {
          transition: 0.7s;
        }
        
        * {
          -webkit-user-select: none;
          user-select: none;
        }
        
        .slide.active {
          box-shadow: 0 0 30px rgba(227, 41, 97, 0.5);
          z-index: 2;
          opacity: 1;
        }
        
        .slide:not(.active) {
          opacity: 0.7;
          z-index: 1;
        }
        
        /* Ensure product cards maintain their z-index during hover */
        .product-card-3d:hover {
          z-index: 10 !important;
        }
        
        /* Navigation buttons responsive styling */
        #prev, #next {
          transition: all 0.3s ease;
        }
        
        /* Mobile-first responsive styling for main section */
        :root {
          --nav-size: 50px;
          --nav-font-size: 14pt;
          --nav-padding: 15px;
          --nav-left: 20px;
          --nav-right: 20px;
        }
        
        @media (max-width: 1200px) {
          :root {
            --nav-size: 48px;
            --nav-font-size: 13pt;
            --nav-padding: 14px;
            --nav-left: 20px;
            --nav-right: 20px;
          }
          
          section {
            margin: 2rem 0 !important;
            font-size: 20pt !important;
          }
          
          h1 {
            font-size: 2.2rem !important;
            margin: 1.5rem 0 !important;
          }
          
          .gallery-section {
            margin: 2rem 0 !important;
          }
          
          .wrap {
            height: 380px;
          }
          
          .slide {
            height: 380px;
            margin: 0 12px;
          }
        }
        
        @media (max-width: 992px) {
          :root {
            --nav-size: 40px;
            --nav-font-size: 12pt;
            --nav-padding: 12px;
            --nav-left: 15px;
            --nav-right: 15px;
          }
          
          section {
            margin: 1.5rem 0 !important;
            font-size: 18pt !important;
            letter-spacing: 0.1em !important;
          }
          
          h1 {
            font-size: 2rem !important;
            margin: 1.2rem 0 !important;
          }
          
          .gallery-section {
            margin: 1.5rem 0 !important;
          }
          
          .wrap {
            height: 350px;
          }
          
          .slide {
            height: 350px;
            margin: 0 12px;
          }
        }
        
        @media (max-width: 768px) {
          :root {
            --nav-size: 36px;
            --nav-font-size: 11pt;
            --nav-padding: 10px;
            --nav-left: 12px;
            --nav-right: 12px;
          }
          
          section {
            margin: 1rem 0 !important;
            font-size: 16pt !important;
            padding: 0 10px !important;
          }
          
          h1 {
            font-size: 1.8rem !important;
            margin: 1rem 0 !important;
            letter-spacing: 0.1em !important;
          }
          
          .gallery-section {
            margin: 1rem 0 !important;
          }
          
          .wrap {
            height: 300px;
            margin: 0 10px;
          }
          
          .slide {
            height: 300px;
            margin: 0 8px;
          }
          
          /* Reduce 3D effects on tablets for better performance */
          .product-card-3d {
            will-change: transform, box-shadow;
          }
        }
        
        @media (max-width: 576px) {
          :root {
            --nav-size: 32px;
            --nav-font-size: 10pt;
            --nav-padding: 8px;
            --nav-left: 8px;
            --nav-right: 8px;
          }
          
          section {
            margin: 0.5rem 0 !important;
            font-size: 14pt !important;
            padding: 0 5px !important;
          }
          
          h1 {
            font-size: 1.5rem !important;
            margin: 0.8rem 0 !important;
            letter-spacing: 0.08em !important;
          }
          
          .gallery-section {
            margin: 0.8rem 0 !important;
          }
          
          .wrap {
            height: 280px;
            margin: 0 5px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
          }
          
          .slide {
            height: 280px;
            margin: 0 5px;
          }
          
          #prev, #next {
            background: rgba(0, 0, 0, 0.8) !important;
          }
          
          /* Optimize 3D effects for mobile */
          .product-card-3d {
            transform-style: flat;
            will-change: transform;
          }
          
          /* Reduce text complexity on mobile */
          .product-card-3d div[style*="fontSize"] {
            font-size: 1rem !important;
          }
        }
        
        @media (max-width: 480px) {
          :root {
            --nav-size: 28px;
            --nav-font-size: 9pt;
            --nav-padding: 6px;
            --nav-left: 6px;
            --nav-right: 6px;
          }
          
          section {
            margin: 0.3rem 0 !important;
            font-size: 12pt !important;
            padding: 0 3px !important;
          }
          
          h1 {
            font-size: 1.3rem !important;
            margin: 0.5rem 0 !important;
            letter-spacing: 0.05em !important;
          }
          
          .gallery-section {
            margin: 0.5rem 0 !important;
          }
          
          .wrap {
            height: 250px;
            left: 50%;
            right: 50%;
            margin-left: -50vw;
            margin-right: -50vw;
            width: 100vw;
          }
          
          .slide {
            height: 250px;
            margin: 0 3px;
          }
          
          /* Further optimize for small screens */
          .product-card-3d {
            border-radius: 8px;
          }
          
          .product-card-3d div[style*="fontSize"] {
            font-size: 0.9rem !important;
            padding: 8px 12px !important;
          }
        }
        
        @media (max-width: 360px) {
          :root {
            --nav-size: 24px;
            --nav-font-size: 8pt;
            --nav-padding: 4px;
            --nav-left: 4px;
            --nav-right: 4px;
          }
          
          section {
            margin: 0.2rem 0 !important;
            font-size: 11pt !important;
            padding: 0 2px !important;
          }
          
          h1 {
            font-size: 1.1rem !important;
            margin: 0.3rem 0 !important;
            letter-spacing: 0.03em !important;
          }
          
          .gallery-section {
            margin: 0.3rem 0 !important;
          }
          
          .wrap {
            height: 220px;
          }
          
          .slide {
            height: 220px;
          }
          
          .product-card-3d div[style*="fontSize"] {
            font-size: 0.8rem !important;
            padding: 6px 10px !important;
          }
        }
        
        /* Touch-friendly interactions */
        @media (hover: none) and (pointer: coarse) {
          .slide {
            cursor: grab;
          }
          
          .slide:active {
            cursor: grabbing;
          }
          
          /* Simplify hover effects on touch devices */
          .product-card-3d:hover {
            transform: none !important;
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3) !important;
          }
        }
      `}</style>
    </section>
  );
};

export { ProductCard };
export default Products;